import { useScrollToTop } from "@/shared/hooks/useScrollToTop";
import Button from "@/shared/ui/buttons/Button";
import { PageLayout } from "@/shared/ui/layouts/PageLayout";
import { SectionLayout } from "@/shared/ui/layouts/SectionLayout";
import Typography from "@/shared/ui/Typography";
import * as React from "react";
import { useNavigate } from "react-router-dom";

export function Notfound() {

    const scrollToTop = useScrollToTop();

    const navigator = useNavigate();
        
    const handleFindYourProperty = () => {
        navigator('/')
    };
    
    React.useEffect(() => {
        scrollToTop();
    }, [scrollToTop]);

    return (
        <PageLayout>
            <SectionLayout 
                className="py-[100px]"
                containerClassName="relative h-full flex flex-col items-center justify-center gap-[28px]"
            >
                <Typography tag="h2" className="text-[20px] md:text-[26px] lg:text-[40px] text-center">
                    кажется этой страницы не существует
                </Typography>
                <img
                    src='/images/backgrounds/404.png'
                    className=""
                    alt=""
                />
                <Typography className="uppercase text-center font-semibold text-[16px] md:text-[20px] md:font-bold lg:text-[26px] !leading-[130%]">
                    Но не волнуйтесь, у нас есть тысячи отличных объектов, которые точно найдутся. Давайте перейдём на главную и продолжим поиск!
                </Typography>

                <Button
                    iconType="search"
                    className="bg-white-50 shadow-bg text-blue text-[14px] md:text-[16px] transition-colors duration-300 ease-in-out origin-left hover:text-white hover:bg-blue"
                    onClick={handleFindYourProperty}
                >
                    Найти свою недвижимость
                </Button>
            </SectionLayout>
        </PageLayout>
    )
}
